module.exports = __webpack_public_path__ + "img/spoken_submit_finish.cb9453ff.svg";